function AFTryUsFreePage() {
}

AFTryUsFreePage.prototype.init = function () {
};

AFTryUsFreePage.prototype.destroy = function () {
};
